import React, { useCallback, useState } from 'react';
import '../../../common/CommonStyle.scss';
import { useSelector } from 'react-redux';
import { getAuth } from '@/selectors/auth';
import { useTranslation } from 'react-i18next';
import { useMixedPlaceholder } from '@/hooks/useMixedPlaceholder';
import { VALIDATION_STATE_WARNING } from '@/utils/validationErrors';

const Publisher = ({
  index,
  item,
  errorBanner,
  validationState,
  handleChange,
  inputs,
  inputNameCustomClass,
  inputPROCustomClass,
  handleDeleteInput,
  handleAddInput,
  disabled,
  nameMixedPlaceholder,
  roleMixedPlaceholder,
  onFocusPublisher,
  onFocusPRO,
}: any) => {
  const [onClickName, setOnClickName] = useState(false);
  const [onClickPRO, setOnClickPRO] = useState(false);
  const [onChangeName, setOnChangeName] = useState(false);
  const [onChangePRO, setOnChangePRO] = useState(false);

  const { hasWriteAccess } = useSelector(getAuth);
  const { t } = useTranslation();
  const validationClassName =
    validationState === VALIDATION_STATE_WARNING
      ? 'warning-input'
      : 'invalid-input';
  const nameError: boolean = onClickName && !onChangeName && !item.name;
  const proError: boolean =
    onClickPRO && !onChangePRO && !item.performing_Rights_Organization;
  const isMixedDisabled = () => {
    return (
      disabled &&
      (item?.performing_Rights_Organization === 'Mixed' ||
        item?.name === 'Mixed')
    );
  };
  const getInputClassName = useCallback(
    (fieldValue: any, onChangeField: any, customClass: any) => {
      let className =
        !fieldValue && hasWriteAccess && !onChangeField && errorBanner
          ? `form-control ${validationClassName}`
          : 'form-control';
      if (customClass) {
        className += ` ${customClass}`;
      }
      return className;
    },
    [
      hasWriteAccess,
      errorBanner,
      inputNameCustomClass,
      inputPROCustomClass,
      validationClassName,
    ]
  );

  const inputNameMixedPlaceholder = useMixedPlaceholder(nameMixedPlaceholder, {
    onBlur: () => {
      setOnClickName(false);
    },
    onClick: () => {
      setOnClickName(true);
    },
  });

  const inputRoleMixedPlaceholder = useMixedPlaceholder(roleMixedPlaceholder, {
    onBlur: () => {
      setOnClickPRO(false);
    },
    onClick: () => {
      setOnClickPRO(true);
    },
  });

  return (
    <>
      <div id={`publisher-${index}`} className="col-sm-12 list-item">
        <div className="pair-input">
          <div className="float-start">
            <input
              type="text"
              className={getInputClassName(
                item.name,
                onChangeName,
                inputNameCustomClass
              )}
              id={`publisherName-${index}`}
              value={item.name ?? ''}
              onChange={(e) => {
                setOnChangeName(true);
                handleChange(e, index, 'name');
              }}
              {...inputNameMixedPlaceholder}
              onFocus={onFocusPublisher}
              disabled={disabled}
            />
          </div>
          <div className="float-end">
            <input
              type="text"
              className={getInputClassName(
                item.performing_Rights_Organization,
                onChangePRO,
                inputPROCustomClass
              )}
              id={`publisherPRO-${index}`}
              value={item.performing_Rights_Organization ?? ''}
              onChange={(e) => {
                setOnChangePRO(true);
                handleChange(e, index, 'performing_Rights_Organization');
              }}
              {...inputRoleMixedPlaceholder}
              onFocus={onFocusPRO}
              disabled={disabled}
            />
          </div>
        </div>
        {!disabled || isMixedDisabled() ? (
          <button
            className="icon-btn"
            onClick={() => handleDeleteInput(index)}
            type="button"
          >
            <i className="icon fas fa-times"></i>
          </button>
        ) : null}
      </div>
      {errorBanner && hasWriteAccess && (nameError || proError) ? (
        <div
          className={
            validationState === VALIDATION_STATE_WARNING
              ? 'col-sm-3 popUp-container-warning'
              : 'col-sm-3 popUp-container'
          }
        >
          {nameError
            ? t('validationAlert.nameRequired.ErrorMessage')
            : proError
              ? t('validationAlert.performingRightsOrgRequired.ErrorMessage')
              : null}
        </div>
      ) : null}
      {index === inputs.length - 1 &&
        (!disabled || isMixedDisabled() ? (
          <div className="col-sm-4 text-start">
            <button
              type="button"
              className="btn add-btn text-end"
              onClick={() => {
                handleAddInput();
              }}
              disabled={isMixedDisabled()}
            >
              <i className="icon fas fa-plus"></i>
              <span>{t('common.button.publisher')}</span>
            </button>
          </div>
        ) : null)}
    </>
  );
};
export default Publisher;
